import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPin, removePin, downloadDoc } from '../../../../../../common/services/http/documentsService';
import { RootState } from '../../../../../../redux/store';
import { PIN_TRIGGER } from '../../../../../../redux/types';
import Pin from '../../../../../ui/button/pin/pin';
import Icon from '../../../../../ui/icon/icon';
import LoadingCell from '../../../../../ui/table/cells/loadingCell/loadingCell';

import './actionsCell.scss';

const ActionsCell = (props) => {
  if (props.dataItem['documentId'] === undefined) return <LoadingCell />;

  const [isPinned, setIsPinned] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const pins = useSelector((state: RootState) => state.pin.pins);
  const impersonate = useSelector((state: RootState) => state.impersonate);

  useEffect(() => {
    setIsPinned(props.dataItem.isPinned);
  }, []);

  useEffect(() => {
    if (pins) {
      if (pins.includes(props.dataItem.assignId)) {
        setIsPinned(true);
      } else {
        setIsPinned(false);
      }
    }
  }, [pins, impersonate]);

  const handlePinClick = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    if (isPinned === false) {
      setPin(+props.dataItem.assignId).then(() => {
        setIsPinned(true);
        dispatch({ type: PIN_TRIGGER });
        setLoading(false);
      });
    } else if (isPinned === true) {
      removePin(+props.dataItem.assignId).then(() => {
        setIsPinned(false);
        dispatch({ type: PIN_TRIGGER });
        setLoading(false);
      });
    }
  };

  return (
    <td className="documentCell pin-cell">
      {props.dataItem.type === 'doc' && (
        <div className="pin-cell-wrapper">
          <Icon className="actions-cell-icon" name="far fa-file-download" onClick={() => downloadDoc(props.dataItem)} />
          <Pin isPinned={isPinned} clickHandler={handlePinClick} loading={loading}/>
        </div>
      )}
    </td>
  );
};

export default ActionsCell;
